module.exports = __webpack_public_path__ + "img/David.55beefde.png";